import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  static values = {
    modalId: String,
    eventName: String,
    eventProperties: String
  }

  connect() {
    if (!this.modal) {
      this.element.removeAttribute("role")
      this.element.removeAttribute("tabindex")
      this.element.removeAttribute("aria-haspopup")
      this.element.removeAttribute("aria-label")
      this.element.classList.remove("tw-cursor-pointer")
      return
    }

    this.eventTracker = new EventTrackerService()
  }

  open(event) {
    // The Redeem CTA (and any future control inside the card) keeps its own
    // behaviour -- the surface only reacts to clicks on the card itself.
    if (event.target.closest("a, button, input, select, textarea, label")) return

    this.show()
  }

  openOnKey(event) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return
    if (event.target !== this.element) return

    event.preventDefault()
    this.show()
  }

  show() {
    const modal = this.modal
    if (!modal) return

    modal.style.display = "flex"
    this.track()
  }

  track() {
    if (!this.eventTracker || !this.eventNameValue) return

    const now = Date.now()
    if (this.lastTrackedAt && now - this.lastTrackedAt < 500) return
    this.lastTrackedAt = now

    this.eventTracker.trackEvent(this.eventNameValue, this.eventPropertiesValue || "{}")
  }

  get modal() {
    if (!this.modalIdValue) return null

    return document.querySelector(`.c-modal-action[data-id="modal-action-${this.modalIdValue}"]`)
  }
}
